import { useState, useEffect } from 'react';
import TemplateApi from 'api/template';

const SelectTemplate = props => {
  const [templates, setTemplates] = useState([]);
  const [fetching, setFetching] = useState(false);

  const { value, id, autofocus, disabled, required, placeholder, readonly, options } = props;
  const { multiple, clearable, classNames } = options;

  const fetchData = async () => {
    setFetching(true);

    try {
      const data = await TemplateApi.fetch();
      setTemplates(data);
    } finally {
      setFetching(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (fetching) {
    return <div>...</div>;
  }

  const renderOptions = () => {
    return templates.map(template => (
      <option value={template.name} key={template.id}>
        {template.description}
      </option>
    ));
  };

  return (
    <select
      id={id}
      defaultValue={value}
      clearable={clearable}
      multiple={multiple}
      autoFocus={autofocus}
      required={required}
      placeholder={placeholder || 'Template'}
      readOnly={readonly}
      disabled={disabled}
      onChange={event => props.onChange(event.target.value)}
      className={`form-select ${classNames || ''}`}>
      {renderOptions()}
    </select>
  );
};

export default SelectTemplate;
